var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGooglePlayStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 41,
    viewBox: "0 0 144 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M138.185 41H5.31481C2.393 41 0 38.6925 0 35.875V5.125C0 2.30754 2.393 4.52891e-06 5.31481 4.52891e-06H138.185C141.107 4.52891e-06 143.5 2.30754 143.5 5.125V35.875C143.5 38.6925 141.107 41 138.185 41Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M138.185 0.821282C140.646 0.821282 142.648 2.75213 142.648 5.125V35.875C142.648 38.2479 140.646 40.1787 138.185 40.1787H5.31481C2.85406 40.1787 0.851699 38.2479 0.851699 35.875V5.125C0.851699 2.75213 2.85406 0.821282 5.31481 0.821282H138.185ZM138.185 4.52891e-06H5.31481C2.393 4.52891e-06 0 2.30754 0 5.125V35.875C0 38.6925 2.393 41 5.31481 41H138.185C141.107 41 143.5 38.6925 143.5 35.875V5.125C143.5 2.30754 141.107 4.52891e-06 138.185 4.52891e-06Z",
    fill: "#A6A6A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.403 10.4999C50.403 11.3557 50.1373 12.0412 49.6138 12.5524C49.0119 13.1584 48.228 13.4634 47.2673 13.4634C46.3492 13.4634 45.5652 13.1533 44.9221 12.5422C44.2777 11.922 43.9562 11.161 43.9562 10.25C43.9562 9.33904 44.2777 8.57798 44.9221 7.96298C45.5652 7.3467 46.3492 7.03664 47.2673 7.03664C47.7244 7.03664 48.1602 7.12761 48.5761 7.29673C48.9906 7.46714 49.3281 7.69776 49.5726 7.9822L49.0172 8.52289C48.5907 8.03729 48.0101 7.7977 47.2673 7.7977C46.5976 7.7977 46.017 8.0232 45.524 8.47804C45.0364 8.93417 44.7919 9.52482 44.7919 10.25C44.7919 10.9752 45.0364 11.571 45.524 12.0271C46.017 12.4768 46.5976 12.7074 47.2673 12.7074C47.9782 12.7074 48.5761 12.4768 49.0478 12.022C49.3587 11.7209 49.5354 11.3058 49.5819 10.7753H47.2673V10.0348H50.3552C50.3924 10.1949 50.403 10.3499 50.403 10.4999Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.302 7.93231H52.4014V9.87981H55.0163V10.6204H52.4014V12.5679H55.302V13.3225H51.5803V7.17766H55.302V7.93231Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7592 13.3225H57.9381V7.93231H56.1589V7.17766H60.5397V7.93231H58.7592V13.3225Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M63.71 13.3225V7.17766H64.5298V13.3225H63.71Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1639 13.3225H67.3494V7.93231H65.5637V7.17766H69.9497V7.93231H68.1639V13.3225Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2437 12.5319C77.6152 13.1533 76.8366 13.4634 75.9078 13.4634C74.9737 13.4634 74.1951 13.1533 73.5667 12.5319C72.9395 11.9118 72.6273 11.1507 72.6273 10.25C72.6273 9.34929 72.9395 8.58823 73.5667 7.96811C74.1951 7.3467 74.9737 7.03664 75.9078 7.03664C76.8313 7.03664 77.6099 7.3467 78.2384 7.97323C78.8708 8.59848 79.1831 9.35442 79.1831 10.25C79.1831 11.1507 78.8708 11.9118 78.2437 12.5319ZM74.1739 12.0169C74.6469 12.4768 75.2222 12.7074 75.9078 12.7074C76.5881 12.7074 77.1688 12.4768 77.6365 12.0169C78.1082 11.5569 78.3473 10.9662 78.3473 10.25C78.3473 9.53379 78.1082 8.94314 77.6365 8.48317C77.1688 8.0232 76.5881 7.79257 75.9078 7.79257C75.2222 7.79257 74.6469 8.0232 74.1739 8.48317C73.7022 8.94314 73.463 9.53379 73.463 10.25C73.463 10.9662 73.7022 11.5569 74.1739 12.0169Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3348 13.3225V7.17766H81.3313L84.4298 11.9567H84.4657L84.4298 10.7754V7.17766H85.2497V13.3225H84.394L81.1493 8.30772H81.1134L81.1493 9.49416V13.3225H80.3348Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4252 22.2963C69.9285 22.2963 67.889 24.1285 67.889 26.6564C67.889 29.1638 69.9285 31.0152 72.4252 31.0152C74.9271 31.0152 76.9667 29.1638 76.9667 26.6564C76.9667 24.1285 74.9271 22.2963 72.4252 22.2963ZM72.4252 29.2984C71.0553 29.2984 69.8767 28.208 69.8767 26.6564C69.8767 25.0843 71.0553 24.0132 72.4252 24.0132C73.7951 24.0132 74.9789 25.0843 74.9789 26.6564C74.9789 28.208 73.7951 29.2984 72.4252 29.2984ZM62.5277 22.2963C60.0257 22.2963 57.9915 24.1285 57.9915 26.6564C57.9915 29.1638 60.0257 31.0152 62.5277 31.0152C65.0283 31.0152 67.0639 29.1638 67.0639 26.6564C67.0639 24.1285 65.0283 22.2963 62.5277 22.2963ZM62.5277 29.2984C61.1564 29.2984 59.9739 28.208 59.9739 26.6564C59.9739 25.0843 61.1564 24.0132 62.5277 24.0132C63.8976 24.0132 65.0761 25.0843 65.0761 26.6564C65.0761 28.208 63.8976 29.2984 62.5277 29.2984ZM50.75 23.6327V25.4854H55.3381C55.2039 26.5206 54.8451 27.2817 54.295 27.8121C53.6254 28.4527 52.5823 29.1638 50.75 29.1638C47.9265 29.1638 45.7156 26.9665 45.7156 24.2438C45.7156 21.5212 47.9265 19.3238 50.75 19.3238C52.2767 19.3238 53.3875 19.8991 54.2073 20.6448L55.5613 19.3392C54.4146 18.2834 52.8893 17.4724 50.75 17.4724C46.8782 17.4724 43.6242 20.5103 43.6242 24.2438C43.6242 27.9774 46.8782 31.0152 50.75 31.0152C52.8427 31.0152 54.4146 30.3541 55.6503 29.1139C56.9166 27.8928 57.3112 26.1759 57.3112 24.7896C57.3112 24.3591 57.274 23.9632 57.2075 23.6327H50.75ZM98.9102 25.0689C98.5368 24.0939 97.3849 22.2963 95.0384 22.2963C92.7131 22.2963 90.7772 24.0632 90.7772 26.6564C90.7772 29.0985 92.6932 31.0152 95.2616 31.0152C97.3384 31.0152 98.5368 29.7942 99.0298 29.0831L97.4885 28.0927C96.9743 28.8179 96.2741 29.2984 95.2616 29.2984C94.2558 29.2984 93.5343 28.8538 93.0719 27.9774L99.1188 25.5648L98.9102 25.0689ZM92.745 26.5206C92.6932 24.8396 94.099 23.9786 95.1061 23.9786C95.8954 23.9786 96.5651 24.3591 96.7883 24.9037L92.745 26.5206ZM87.8302 30.75H89.8179V17.9375H87.8302V30.75ZM84.5748 23.2675H84.5084C84.062 22.7576 83.2103 22.2963 82.1314 22.2963C79.8672 22.2963 77.7971 24.2131 77.7971 26.6705C77.7971 29.1139 79.8672 31.0152 82.1314 31.0152C83.2103 31.0152 84.062 30.5501 84.5084 30.0248H84.5748V30.6501C84.5748 32.317 83.6514 33.2126 82.1619 33.2126C80.9475 33.2126 80.1941 32.3669 79.8832 31.6559L78.1545 32.3516C78.6528 33.5073 79.9722 34.9294 82.1619 34.9294C84.4925 34.9294 86.4589 33.6072 86.4589 30.39V22.5615H84.5748V23.2675ZM82.3014 29.2984C80.9315 29.2984 79.7849 28.1926 79.7849 26.6705C79.7849 25.1343 80.9315 24.0132 82.3014 24.0132C83.6514 24.0132 84.7157 25.1343 84.7157 26.6705C84.7157 28.1926 83.6514 29.2984 82.3014 29.2984ZM108.216 17.9375H103.462V30.75H105.445V25.8954H108.216C110.418 25.8954 112.577 24.3591 112.577 21.9158C112.577 19.4737 110.413 17.9375 108.216 17.9375ZM108.268 24.1131H105.445V19.7197H108.268C109.748 19.7197 110.594 20.9049 110.594 21.9158C110.594 22.9075 109.748 24.1131 108.268 24.1131ZM120.523 22.272C119.091 22.272 117.601 22.8819 116.989 24.2336L118.748 24.9447C119.126 24.2336 119.823 24.0029 120.559 24.0029C121.587 24.0029 122.63 24.5987 122.646 25.6506V25.7852C122.287 25.5853 121.519 25.2893 120.575 25.2893C118.68 25.2893 116.749 26.2951 116.749 28.1721C116.749 29.889 118.301 30.9947 120.046 30.9947C121.38 30.9947 122.116 30.4143 122.578 29.7391H122.646V30.7295H124.561V25.8146C124.561 23.543 122.802 22.272 120.523 22.272ZM120.284 29.2932C119.635 29.2932 118.732 28.9832 118.732 28.208C118.732 27.2163 119.859 26.8358 120.834 26.8358C121.707 26.8358 122.116 27.0216 122.646 27.2663C122.491 28.4527 121.432 29.2932 120.284 29.2932ZM131.537 22.5526L129.258 28.1068H129.19L126.834 22.5526H124.696L128.236 30.3144L126.216 34.6335H128.288L133.742 22.5526H131.537ZM113.667 30.75H115.655V17.9375H113.667V30.75Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.092 7.72726C10.7798 8.04244 10.5991 8.53316 10.5991 9.16866V31.8365C10.5991 32.472 10.7798 32.9628 11.092 33.2779L11.1691 33.3471L24.3418 20.6499V20.3501L11.1691 7.65295L11.092 7.72726Z",
    fill: "url(#paint0_linear_9475_10116)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7278 24.8844L24.3417 20.6499V20.3501L28.7331 16.1156L28.8314 16.1707L34.032 19.024C35.5161 19.8338 35.5161 21.1663 34.032 21.9811L28.8314 24.8293L28.7278 24.8844Z",
    fill: "url(#paint1_linear_9475_10116)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8315 24.8294L24.3418 20.5L11.092 33.2779C11.5849 33.7776 12.3888 33.8378 13.3029 33.3382L28.8315 24.8294Z",
    fill: "url(#paint2_linear_9475_10116)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8315 16.1706L13.3029 7.6618C12.3888 7.16724 11.5849 7.22746 11.092 7.72714L24.3418 20.4999L28.8315 16.1706Z",
    fill: "url(#paint3_linear_9475_10116)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9475_10116",
    x1: 23.1723,
    y1: 32.0726,
    x2: 5.98166,
    y2: 14.2453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9475_10116",
    x1: 35.9646,
    y1: 20.4986,
    x2: 10.2442,
    y2: 20.4986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9475_10116",
    x1: 26.3901,
    y1: 18.1465,
    x2: 3.0783,
    y2: -6.0287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9475_10116",
    x1: 7.75672,
    y1: 40.8193,
    x2: 18.1665,
    y2: 30.0241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlayStore);
export default __webpack_public_path__ + "static/media/google-play-store.64776f09d8a16ced1527e11764ad7a39.svg";
export { ForwardRef as ReactComponent };